import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ResetWalletAction } from 'src/app/angular-wallet-base/actions/wallet.actions';
import { MembersPortalService } from 'src/app/angular-wallet-base/services/members-portal.service';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { confirmResetWalletAlert } from 'src/app/angular-wallet-base/utils';

@Component({
  selector: 'pin-input',
  templateUrl: './pin-input.component.html',
  styleUrls: ['./pin-input.component.scss'],
})
export class PinInputComponent implements OnInit, OnChanges {

  @Input() pageTitle = '';
  @Input() showPinError = false;
  @Input() upgradeInProgress = false;
  @Input() pinLength = 6;
  @Input() pin = '';
  @Input() showForgotPin = false;

  @Output() pinComplete: EventEmitter<string> = new EventEmitter<string>();
  @Output() pinClear: EventEmitter<string> = new EventEmitter<string>();

  public pinLengthArr = new Array(this.pinLength);

  constructor(
    private alertController: AlertController,
    private translate: TranslateService,
    private membersPortalService: MembersPortalService,
    private nav: NavController,
    protected store: Store<AppState>,
  ) {}

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (changes.showPinError && changes.showPinError.currentValue === true) {
      setTimeout(() => {
        this.handleClear();
      }, 860); // timing to match css animation
    }
  }

  handleInput(pin: string) {
    this.pin += pin;
    if (this.pin.length === this.pinLength) {
      setTimeout(() => {
      this.pinComplete.emit(this.pin);        
      }, 100);// timing to apply css style
    }
  }

  handleClear() {
    this.pin = '';
    this.pinClear.emit();
  }

  handleErase() {
    this.pin = this.pin.slice(0, this.pin.length === 0 ? 0 : this.pin.length - 1);
  }
  
  async confirmRestore() {
    const handler = async (data) => {
      await this.membersPortalService.removeAccount();
      await this.nav.navigateForward('/setup/setup-pin/recover',  { queryParams: { restore: true} });
    };
    await confirmResetWalletAlert(this.alertController, this.translate, handler);
  }
}
